<template>
	<div v-if="show" @click.self="dismissModal()" class="fixed pin z-50 overflow-hidden bg-smoke-lighter flex">
		<div class="relative bg-grey-lightest w-full max-w-md m-auto flex-col flex rounded m-8 overflow-scroll shadow-modal">
			<div class="w-full bg-green-light py-1"></div>
			<div class="flex py-2 m-2 px-4">
				<div class="flex-1 text-left">
					<p class="text-lg font-extrabold">Välj inställningar för sidan</p>
				</div>
				<div class="flex-1">
					<button @click="dismissModal()" class="float-right text-grey hover:text-grey-darker">
						<svg class="fill-current h-5 w-5" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M23.954 21.03l-9.184-9.095 9.092-9.174-2.832-2.807-9.09 9.179-9.176-9.088-2.81 2.81 9.186 9.105-9.095 9.184 2.81 2.81 9.112-9.192 9.18 9.1z"/></svg>
					</button>
				</div>
			</div>

			<div class="h-full mx-6 mb-6 pb-2 pt-3">
				<div class="flex justify-center flex-wrap">

					<div class="w-3/4 mb-4">
						<p class="text-left font-semibold mb-2">Sidlayout</p>
						<div class="relative ml-2">
							<select v-model="paperType" class="block appearance-none w-full bg-white border border-grey-light hover:border-grey px-4 py-2 pr-8 rounded shadow leading-tight focus:outline-none focus:shadow-outline">
								<option v-for="type in paperTypes" :key="type.slug" :value="type.slug" v-text="type.title"></option>
							</select>
							<div class="pointer-events-none absolute pin-y pin-r flex items-center px-2 text-grey-darker">
								<svg class="fill-current h-4 w-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"/></svg>
							</div>
						</div>
					</div>

					<div class="w-3/4 mb-4">
						<p class="text-left font-semibold mb-2">Analys</p>
						<div class="relative ml-2">
							<select v-model="interpolationType" class="block appearance-none w-full bg-white border border-grey-light hover:border-grey px-4 py-2 pr-8 rounded shadow leading-tight focus:outline-none focus:shadow-outline">
								<option v-for="type in filteredAnalysisTypes" :key="type.slug" :value="type.slug" v-text="type.title"></option>
							</select>
							<div class="pointer-events-none absolute pin-y pin-r flex items-center px-2 text-grey-darker">
								<svg class="fill-current h-4 w-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"/></svg>
							</div>
						</div>
					</div>

					<div class="w-3/4 mb-4">
						<p class="text-left font-semibold mb-2">Interpoleringsalgoritm</p>
						<div class="ml-4 flex flex-wrap justify-start">

							<div class="w-full">

								<label class="radiobutton-container">
									<input type="radio" value="1" v-model="interpolationAlgorithm">
									<span class="radiobutton-text">Traditionell</span>
									<span class="radiobutton"></span>
								</label>

								<label class="radiobutton-container">
									<input type="radio" value="3" v-model="interpolationAlgorithm">
									<span class="radiobutton-text">Ny interpolationsteknik</span>
									<span class="radiobutton"></span>
								</label>

							</div>
						</div>
					</div>
					<div class="w-3/4 mb-4">
						<p class="text-left font-semibold mb-2">Mjuka färgövergångar</p>

						<label class="ml-4 mt-1 checkbox-container">
							<input type="checkbox" v-model="interpolationColorSmoothing">
							<span class="checkmark"></span>
							<span class="checkmark-text">Använd mjuka färgövergångar</span>
						</label>
					</div>

					<div class="w-3/4 mb-4">
						<p class="text-left font-semibold mb-2">Skala</p>
						<div class="relative ml-2">
							<select v-model="scale" class="block appearance-none w-full bg-white border border-grey-light hover:border-grey px-4 py-2 pr-8 rounded shadow leading-tight focus:outline-none focus:shadow-outline">
								<option :value="0">Ingen skala</option> 
								<option v-for="scale in scales" :key="scale.value" :value="scale.value" v-text="scale.title"></option> 
							</select>
							<div class="pointer-events-none absolute pin-y pin-r flex items-center px-2 text-grey-darker">
								<svg class="fill-current h-4 w-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"/></svg>
							</div>
						</div>
					</div>

					<div class="w-3/4 mb-4">
						<p class="text-left font-semibold mb-2">Textstorlek på karta <small>(10-100)</small></p>
						<div class="ml-2">
							<input class="input-text" v-model.number="fontSize">
						</div>
					</div>

					<div class="w-3/4 mb-4">
						<p class="text-left font-semibold mb-2">Visa text på karta</p>

						<label class="ml-4 mt-1 checkbox-container">
							<input type="checkbox" v-model="showText">
							<span class="checkmark"></span>
							<span class="checkmark-text">Visa</span>
						</label>
					</div>
				</div>

			</div>

			<div class="w-full bg-grey-lightish py-4">
				<div class="float-right mr-4">
					<button @click="saveSettings()" class="float-right py-2 px-2 text-sm text-center text-white block bg-green hover:bg-green-dark rounded shadow-light font-bold">
						Spara inställningar
					</button>
				</div>
			</div>

		</div>
	</div>
</template>

<script>

import { mapGetters } from 'vuex'

export default {

	data() {
		return {
			show: false,
			page_id: null,
			paperType: null,
			interpolationType: null,
			interpolationAlgorithm: null,
			interpolationColorSmoothing: false,
			fontSize: null,
			showText: true,
			scale: 0,
		}
	},

	computed: {

		...mapGetters({
			analysisTypes:	'analysis/types',
			paperTypes:		'layout/paperTypes',
			scales:			'layout/scales',
		}),

		page() {
			return this.$store.getters['layout/getPageById'](this.page_id)
		},

		filteredAnalysisTypes() {
			if(this.page && Object.keys(this.page.currentAnalyses).length) {
				return this.analysisTypes.filter(type => {
					return this.page.currentAnalyses[type.slug] && this.page.currentAnalyses[type.slug] > 0
				})
			}
			return this.analysisTypes
		}
	},

	watch: {
		page() {
			if(!this.paperType) {
				this.paperType = this.page.paperType.slug
			}
		}
	},

	mounted() {
		bus.$on('open-page-settings-modal', this.openModal)
		bus.$on('close-page-settings-modal', this.dismissModal)
	},

    beforeDestroy() {
        bus.$off('open-page-settings-modal')
        bus.$off('close-page-settings-modal')
    },

	methods: {
		openModal(page_id = null) {
			this.page_id = page_id

			this.paperType = this.page.paperType.slug
			this.interpolationType = this.page.interpolationSettings.interpolationType
			this.interpolationAlgorithm = this.page.interpolationSettings.interpolationAlgorithm
			this.interpolationColorSmoothing = this.page.interpolationSettings.interpolationColorSmoothing
			this.fontSize = this.page.fontSize
			this.scale = this.page.scale
			this.showText = this.page.showText

			this.show = true
			document.getElementById("body").className = "overflow-y-hidden";
			bus.$emit('deselect')
		},
		
		dismissModal() {
			this.show = false
			document.getElementById("body").className = "";
		},
		
		/**
		 * Will create a settings object that only
		 * contains attribute that have been changed
		 */
		saveSettings() {
			if(this.fontSize >= 10 && this.fontSize <=100) {
				let iSettings = this.page.interpolationSettings
				let settings = {id: this.page_id}

				if(this.paperType != this.page.paperType.slug) {
					settings.paperType = this.paperType
				}
				if(this.interpolationType != iSettings.interpolationType) {
					settings.interpolationType = this.interpolationType
				}
				if(this.interpolationAlgorithm != iSettings.interpolationAlgorithm) {
					settings.interpolationAlgorithm = this.interpolationAlgorithm
				}
				if(this.interpolationColorSmoothing != iSettings.interpolationColorSmoothing) {
					settings.interpolationColorSmoothing = this.interpolationColorSmoothing
				}
				if(this.fontSize != this.page.fontSize) {
					settings.fontSize = this.fontSize
				}
				if(this.scale != this.page.scale) {
					settings.scale = this.scale
				}
				if(this.showText != this.page.showText) {
					settings.showText = this.showText
				}
				
				this.$store.dispatch("layout/SET_PAGE_SETTINGS", settings)
	
				this.dismissModal()
			} else {
				bus.$emit('show-notification', '', 'Textstorleken måste vara mellan 10 och 100')
			}
		}
	}
}
</script>